<script>
import TextSwitcher from '@/components/org/TextSwitcher'
import NumericRangeSelector from '@/components/org/NumericRangeSelector'
import ToggleButtonGroup from '@/components/org/ToggleButtonGroup'
import MatchSignupStaffConfig from '@/tbs/model/vo/MatchSignupStaffConfig'

const matchSignupStaffConfig = new MatchSignupStaffConfig

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-staff-config-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'text-switcher': TextSwitcher,
        'numeric-range-selector': NumericRangeSelector,
        'toggle-button-group': ToggleButtonGroup,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchGroup: {
                id: null,
                isStaffOn: null,
                staffNumMin: null,
                staffNumMax: null,
                isIdentificationNumRequired: null,
                isPhotoRequired: null,
                staffDutyItems: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSaveBtnClick() {
            this.$emit('custom-event', {
                type: 'save',
                data: this.matchGroup
            })
        },
        onStaffOnDataChange(data) {
            console.log('onStaffOnDataChange', data)
            if (data == this.matchGroup.isStaffOn) {
                return
            }
            this.matchGroup.isStaffOn = data
            if (data) {
                this.matchGroup.staffNumMin = 1
                this.matchGroup.staffNumMax = 5
                this.matchGroup.isIdentificationNumRequired = false
                this.matchGroup.isPhotoRequired = false
                this.matchGroup.staffDutyItems = matchSignupStaffConfig.getDefaultStaffDutyItems()
            }
            else {
                this.matchGroup.staffDutyItems = []
            }
            this.submitData()
        },
        onStaffNumDataChange(data) {
            console.log('onStaffNumDataChange', data)
            if (data.min == this.matchGroup.staffNumMin 
                && data.max == this.matchGroup.staffNumMax) {
                return
            }
            this.matchGroup.staffNumMin = data.min
            this.matchGroup.staffNumMax = data.max
            this.submitData()
        },
        onStaffIdentificationNumDataChange(data) {
            if (data == this.matchGroup.isIdentificationNumRequired) {
                return
            }
            this.matchGroup.isIdentificationNumRequired = data
            this.submitData()
        },
        onStaffPhotoDataChange(data) {
            if (data == this.matchGroup.isPhotoRequired) {
                return
            }
            this.matchGroup.isPhotoRequired = data
            this.submitData()
        },
        onStaffDutyItemDataChange(data) {
            this.matchGroup.staffDutyItems = data
            this.submitData()
        },
        submitData() {
            console.log('submit data', this.matchGroup)
            this.$emit('custom-event', {
                type: 'submit',
                data: this.matchGroup
            })
        },
    },
}
</script>

<template>
    <div class="match-signup-staff-config-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <text-switcher 
            :label="locale['staff-signup-data']"
            :checked="matchGroup.isStaffOn"
            @change-data="onStaffOnDataChange"
        />
        <div v-if="matchGroup.isStaffOn">
            <numeric-range-selector
                :label="locale['staff-number']"
                :unit="locale['person']"
                :min="1"
                :down="matchGroup.staffNumMin"
                :up="matchGroup.staffNumMax"
                @change-data="onStaffNumDataChange"
            />
            <text-switcher 
                :label="locale['fill-identification-num']"
                :checked="matchGroup.isIdentificationNumRequired"
                @change-data="onStaffIdentificationNumDataChange"
            />
            <text-switcher 
                :label="locale['upload-photo']"
                :checked="matchGroup.isPhotoRequired"
                @change-data="onStaffPhotoDataChange"
            />
            <text-switcher 
                :label="locale['signup-staff-role']"
                :separated="false"
                :hidden="true"
            />
            <toggle-button-group
                :items="matchGroup.staffDutyItems"
                :input-mode="true"
                :input-label="locale['add']"
                :input-placeholder="locale['add-item-placeholder']"
                @change-data="onStaffDutyItemDataChange"
            />
        </div>
    </div>
</template>